import classNames from 'classnames';
import { FC, HTMLAttributes } from 'react';

interface IIconProps extends HTMLAttributes<HTMLElement> {
  onClick?: () => void;
  name: string;
  className?: string;
  isInteractive?: boolean;
}

const Icon: FC<IIconProps> = ({
  name,
  className,
  isInteractive,
  onClick,
  ...props
}) => {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <i
      aria-label={props?.['aria-label']}
      className={classNames('icon', `icon_${name}`, className)}
      onClick={onClick}
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      {...props}
    />
  );
};

export default Icon;
